export default __webpack_public_path__ + "static/media/sal.ff500cbc.jpg";